export default [
  {
    id: 1,
    slug: 'evert',
    name: 'Evert Holleman',
    role: 'BU Director',
    company: 'Royal HaskoningDHV',
    src: '/img/references/mister.png',
    url: ''
  },
  {
    id: 2,
    slug: 'robert',
    name: 'Robert van Oijen',
    role: 'Leading HR Advisor',
    company: 'Royal HaskoningDHV',
    src: '/img/references/mister.png',
    url: 'https://www.linkedin.com/in/marlous-molder'
  },
  {
    id: 3,
    slug: 'hilde',
    name: 'Hilde De Jonge',
    role: 'Managing Director MCO Group',
    company: 'Atrium Innovations',
    src: '/img/references/miss.png',
    url: 'https://www.linkedin.com/in/marlous-molder'
  }

]
